import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { base_request } from "@/api/faceServe/index";
import { kFaceApiPathFaceStart } from "@/api/faceServe/constants";
/**
 * 明星相似度接口
 * @param source_img
 * @param group
 */
// star - 所有
// model - 模特
// singer - 歌手
// socialMediaStar - 社交媒体明星
// actor - 演员
// athlete - 运动员
// politician - 政治家
// billionaire - 亿万富翁
// historicalFigures - 历史名人

export var faceStar =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(source_img) {
    var group,
        faceStarResult,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            group = _args.length > 1 && _args[1] !== undefined ? _args[1] : "star";
            _context.prev = 1;
            _context.next = 4;
            return base_request(kFaceApiPathFaceStart, {
              method: "POST",
              data: {
                group: group,
                source_img: source_img
              }
            });

          case 4:
            faceStarResult = _context.sent;
            console.log("faceStarResult:", faceStarResult);
            return _context.abrupt("return", faceStarResult);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            console.log("faceStarResult error:", _context.t0);
            return _context.abrupt("return", _Promise.reject(_context.t0));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function faceStar(_x) {
    return _ref.apply(this, arguments);
  };
}();